import Item from '../item';
import { HATCHLINGS, ITEM_STATS } from '../item/item-types';
import { PageSubTitle } from '../menu/page-sub-title';

const EggIndex: React.FC = () => {
    return (
        <div className='egg-index' id='eggs'>
            <PageSubTitle
                label='Eggs'
                name='egg-index'
                image='/resources/compendium/egg_icon.png'
            />
            <div className='egg-index-content'>
                {HATCHLINGS.map(creatureName => {
                    const eggName = ITEM_STATS[creatureName].components?.[0];

                    return eggName && (<div className='egg-index-entry'>
                        <Item key={eggName} itemName={eggName} />
                        <img height={60} width={40} src={`/resources/menu/menu_arrow.png`} alt='Arrow' />
                        <Item key={creatureName} itemName={creatureName} /></div>
                    )
                })}
            </div>
        </div>
    );
};

export default EggIndex;